import { faMapPin } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Dropoff } from "../../../models/Dropoff";
import { MapObject } from "../../../models/MapObject";
import AreaAvatar from "../../Map/AreaAvatar";
import DamnMappableAttachments from "../damnMappableAttachments";

interface DropoffSectionProps {
    dropoff: Dropoff | null;
    dropoffMapObject: MapObject | null;
}

const DropoffSection: React.FC<DropoffSectionProps> = ({ dropoff, dropoffMapObject }) => {
    if (!dropoff || !dropoffMapObject) {
        return null;
    }

    return (
        <div className="p-4 bg-linear-to-r from-plot-orange/5 to-plot-orange/10 rounded-lg mx-4 mb-4">
            <div className="flex flex-col  xl:flex-row flex-1 w-full justify-between gap-2">
                <div className="flex flex-row items-center gap-3 px-4 py-3">
                    <FontAwesomeIcon icon={faMapPin} className=" text-green-500 shrink-0" size="lg" />
                    <div className="flex-1 w-full">
                        <p className="text-xs text-gray-600 font-medium">Drop off at:</p>
                        <div className="flex flex-row items-center text-base font-bold text-gray-900">
                            <AreaAvatar mappable={dropoff} mapObject={dropoffMapObject} />
                            {dropoff?.name}
                        </div>
                    </div>
                </div>
                <DamnMappableAttachments mappable={dropoff} />
            </div>
        </div>
    );
};

export default DropoffSection;
